import styled, { css } from 'styled-components';
import { useFiltersTheme } from '../../filters-theme-provider';
import { Checkbox } from './checkbox/checkbox';

type ChecklistItemProps = {
  label: string;
  description?: string;
  selected?: boolean;
  onToggle: () => void;
};

export function ChecklistItem({
  label,
  description,
  selected,
  onToggle,
  ...forwardingProps
}: ChecklistItemProps) {
  const { textColor } = useFiltersTheme();

  return (
    <ItemContainer $textColor={textColor} {...forwardingProps}>
      <Checkbox
        aria-label={label}
        onClick={onToggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onToggle();
          }
        }}
        checked={selected}
      />
      <TextContainer>
        <Label>{label}</Label>
        {description && <Description>{description}</Description>}
      </TextContainer>
    </ItemContainer>
  );
}

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-wrap: balance;
`;

const Description = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  opacity: 0.5;
`;

const ItemContainer = styled.label<{
  $textColor: string;
}>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;

  ${({ $textColor }) => css`
    ${Label}, ${Description} {
      color: ${$textColor};
    }
  `}
`;
